module.exports = __webpack_public_path__ + "assets/ec2m.02d649e8.svg";